import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RouteGuard, ValidationGuard } from './core/guards';
import { CoursesResolver, CourseTemplatesResolver, RegionsResolver } from './core/resolvers';
import { ConfirmPage, ContactPage, CoursesPage, ErrorPage, OrderPage, PaymentPage, ThanksPage } from './pages';

const appRoutes: Routes = [
  { path: '', redirectTo: 'courses', pathMatch: 'full' },
  {
    path: 'students',
    canActivate: [RouteGuard],
    canDeactivate: [ValidationGuard],
    component: ContactPage
  },
  {
    path: 'payment',
    canActivate: [RouteGuard],
    canDeactivate: [ValidationGuard],
    component: PaymentPage
  },
  { path: 'confirm', canActivate: [RouteGuard], component: ConfirmPage },
  { path: 'order/:order', component: OrderPage },
  { path: 'thanks', component: ThanksPage },
  { path: 'error', component: ErrorPage },
  {
    path: 'courses',
    component: CoursesPage,
    resolve: {
      courses: CoursesResolver,
      courseTemplates: CourseTemplatesResolver,
      regions: RegionsResolver
    }
  },
  { path: '**', redirectTo: 'courses', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
